var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _g3, _g4, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g5, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _g6, _g7, _g8, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _g9, _path103, _path104, _path105, _path106, _path107, _path108, _g10, _path109, _path110, _path111, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _g19, _g20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudTablet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 326,
    viewBox: "0 0 768 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M657.769 135.118L657.738 149.163L612.537 119.693L612.568 105.648L657.769 135.118Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M702.665 105.648L657.769 135.118L612.568 105.648L657.479 76.1953L702.665 105.648Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M657.601 75.7484L612.705 105.218L567.504 75.7484L612.415 46.2958L657.601 75.7484Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M791.872 165.447L791.842 179.492L746.946 208.962L746.977 194.916L791.872 165.447Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M746.977 194.916L746.946 208.962L701.745 179.492L701.776 165.447L746.977 194.916Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M791.872 165.447L746.977 194.916L701.776 165.447L746.687 135.994L791.872 165.447Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M703.584 154.837L703.554 168.883L658.658 198.353L658.688 184.307L703.584 154.837Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M658.689 184.307L658.658 198.353L613.457 168.883L613.488 154.837L658.689 184.307Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M703.584 154.837L658.689 184.307L613.488 154.837L658.399 125.385L703.584 154.837Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M276.107 58.9223L276.076 72.9679L230.875 43.4981L230.906 29.4525L276.107 58.9223Z",
    fill: "#F0F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M321.003 29.4526L276.107 58.9224L230.906 29.4526L275.817 0L321.003 29.4526Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M232.715 30.3687L232.684 44.4143L187.788 73.8841L187.819 59.8385L232.715 30.3687Z",
    fill: "#F0F0F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M187.819 59.8385L187.788 73.8841L142.587 44.4143L142.618 30.3687L187.819 59.8385Z",
    fill: "#F0F0F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M232.715 30.3688L187.819 59.8386L142.618 30.3688L187.529 0.916199L232.715 30.3688Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M366.066 59.352L321.171 88.8218L275.969 59.352L320.881 29.8994L366.066 59.352Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M411.13 30.417L411.1 44.4626L366.204 73.9324L366.234 59.8868L411.13 30.417Z",
    fill: "#F0F0F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M411.13 30.4171L366.234 59.8869L321.033 30.4171L365.944 0.964478L411.13 30.4171Z",
    fill: "white",
    fillOpacity: 0.7
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M702.833 165.017L702.802 179.063L657.601 149.593L657.632 135.547L702.833 165.017Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.728 135.547L702.833 165.017L657.632 135.547L702.543 106.095L747.728 135.547Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M791.872 105.648L791.842 119.693L746.946 149.163L746.977 135.118L791.872 105.648Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.872 105.648L746.977 135.118L701.776 105.648L746.687 76.1953L791.872 105.648Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M791.872 47.778L791.842 61.8235L746.946 91.2933L746.977 77.2478L791.872 47.778Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M746.977 77.2478L746.946 91.2933L701.745 61.8235L701.776 47.778L746.977 77.2478Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.872 47.778L746.977 77.2478L701.776 47.778L746.687 18.3254L791.872 47.778Z",
    fill: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M613.457 105.648L613.427 119.693L568.531 149.163L568.561 135.118L613.457 105.648Z",
    fill: "#F0F0F0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M568.561 135.118L568.531 149.163L523.33 119.693L523.36 105.648L568.561 135.118Z",
    fill: "#F0F0F0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M613.457 105.648L568.561 135.118L523.36 105.648L568.271 76.1953L613.457 105.648Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M658.521 134.583L658.49 148.628L613.594 178.098L613.625 164.053L658.521 134.583Z",
    fill: "#F0F0F0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M613.625 164.053L613.594 178.098L568.393 148.628L568.424 134.583L613.625 164.053Z",
    fill: "#F0F0F0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M658.521 134.583L613.625 164.053L568.424 134.583L613.335 105.13L658.521 134.583Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M702.665 164.482L702.634 178.528L657.738 207.997L657.769 193.952L702.665 164.482Z",
    fill: "#F0F0F0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M657.769 193.952L657.738 207.997L612.537 178.528L612.568 164.482L657.769 193.952Z",
    fill: "#F0F0F0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M702.665 164.482L657.769 193.952L612.568 164.482L657.479 135.03L702.665 164.482Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M153.623 96.9673L153.593 111.013L108.697 140.483L108.728 126.437L153.623 96.9673Z",
    fill: "#F0F0F0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M108.727 126.437L108.697 140.483L63.4958 111.013L63.5264 96.9673L108.727 126.437Z",
    fill: "#F0F0F0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M153.623 96.9674L108.727 126.437L63.5264 96.9674L108.437 67.5148L153.623 96.9674Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M67.1746 96.0028L67.1441 110.048L22.2483 139.518L22.2788 125.473L67.1746 96.0028Z",
    fill: "#F0F0F0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M22.2787 125.473L22.2482 139.518L-22.9529 110.048L-22.9223 96.0028L22.2787 125.473Z",
    fill: "#F0F0F0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1745 96.0029L22.2787 125.473L-22.9224 96.0029L21.9887 66.5503L67.1745 96.0029Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M366.986 118.312L366.956 132.358L322.06 161.828L322.09 147.782L366.986 118.312Z",
    fill: "#F0F0F0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M322.09 147.782L322.06 161.828L276.859 132.358L276.889 118.312L322.09 147.782Z",
    fill: "#F0F0F0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M366.986 118.312L322.09 147.782L276.889 118.312L321.8 88.8598L366.986 118.312Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M22.1109 125.902L22.0803 139.948L-22.8154 169.418L-22.7849 155.372L22.1109 125.902Z",
    fill: "#F0F0F0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1108 125.902L-22.785 155.372L-67.9861 125.902L-23.075 96.4497L22.1108 125.902Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277.946 118.595L277.916 132.641L232.715 103.171L232.745 89.1252L277.946 118.595Z",
    fill: "#F0F0F0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M322.842 89.1253L277.946 118.595L232.745 89.1253L277.656 59.6727L322.842 89.1253Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.21 89.1252L410.18 103.171L365.284 132.641L365.315 118.595L410.21 89.1252Z",
    fill: "#F0F0F0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M410.21 89.1253L365.315 118.595L320.114 89.1253L365.025 59.6727L410.21 89.1253Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M524.417 105.218L524.387 119.264L479.186 89.7939L479.216 75.7484L524.417 105.218Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.313 75.7484L524.417 105.218L479.216 75.7484L524.127 46.2958L569.313 75.7484Z",
    fill: "white"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M524.249 104.761L524.219 118.807L479.323 148.277L479.354 134.231L524.249 104.761Z",
    fill: "#F0F0F0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M479.353 134.231L479.323 148.277L434.122 118.807L434.152 104.761L479.353 134.231Z",
    fill: "#F0F0F0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M524.249 104.761L479.353 134.231L434.152 104.761L479.063 75.3087L524.249 104.761Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M455.274 118.312L455.244 132.358L410.348 161.828L410.378 147.782L455.274 118.312Z",
    fill: "#F0F0F0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M410.378 147.782L410.348 161.828L365.147 132.358L365.177 118.312L410.378 147.782Z",
    fill: "#F0F0F0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M455.274 118.312L410.378 147.782L365.177 118.312L410.088 88.8598L455.274 118.312Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M569.313 133.948L569.283 147.994L524.387 177.464L524.417 163.418L569.313 133.948Z",
    fill: "#F0F0F0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M524.417 163.418L524.387 177.464L479.186 147.994L479.216 133.948L524.417 163.418Z",
    fill: "#F0F0F0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M569.313 133.948L524.417 163.418L479.216 133.948L524.127 104.496L569.313 133.948Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M613.457 163.136L613.427 177.181L568.531 206.651L568.561 192.605L613.457 163.136Z",
    fill: "#F0F0F0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M568.561 192.605L568.531 206.651L523.33 177.181L523.36 163.136L568.561 192.605Z",
    fill: "#F0F0F0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M613.457 163.136L568.561 192.605L523.36 163.136L568.271 133.683L613.457 163.136Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M500.338 147.5L500.307 161.545L455.412 191.015L455.442 176.969L500.338 147.5Z",
    fill: "#F0F0F0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M455.442 176.969L455.412 191.015L410.21 161.545L410.241 147.5L455.442 176.969Z",
    fill: "#F0F0F0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M500.338 147.5L455.442 176.969L410.241 147.5L455.152 118.047L500.338 147.5Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.05 147.5L412.019 161.545L367.124 191.015L367.154 176.969L412.05 147.5Z",
    fill: "#F0F0F0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M367.154 176.969L367.123 191.015L321.922 161.545L321.953 147.5L367.154 176.969Z",
    fill: "#F0F0F0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M412.05 147.5L367.154 176.969L321.953 147.5L366.864 118.047L412.05 147.5Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M457.114 176.687L457.083 190.732L412.187 220.202L412.218 206.156L457.114 176.687Z",
    fill: "#F0F0F0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.218 206.156L412.187 220.202L366.986 190.732L367.017 176.687L412.218 206.156Z",
    fill: "#F0F0F0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M457.113 176.687L412.218 206.157L367.017 176.687L411.928 147.234L457.113 176.687Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M545.402 176.687L545.371 190.732L500.475 220.202L500.506 206.156L545.402 176.687Z",
    fill: "#F0F0F0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M500.506 206.156L500.475 220.202L455.274 190.732L455.305 176.687L500.506 206.156Z",
    fill: "#F0F0F0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M545.402 176.687L500.506 206.157L455.305 176.687L500.216 147.234L545.402 176.687Z",
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M502.177 205.874L502.147 219.919L457.251 249.389L457.282 235.344L502.177 205.874Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M457.281 235.344L457.251 249.389L412.05 219.919L412.08 205.874L457.281 235.344Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.177 205.874L457.281 235.344L412.08 205.874L456.991 176.421L502.177 205.874Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M745.889 194.382L745.859 208.427L700.963 237.897L700.993 223.851L745.889 194.382Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M700.993 223.851L700.963 237.897L655.762 208.427L655.792 194.382L700.993 223.851Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.889 194.382L700.993 223.851L655.792 194.382L700.703 164.929L745.889 194.382Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M656.681 193.417L656.651 207.463L611.755 236.932L611.786 222.887L656.681 193.417Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M611.786 222.887L611.755 236.932L566.554 207.463L566.584 193.417L611.786 222.887Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.681 193.417L611.786 222.887L566.584 193.417L611.496 163.964L656.681 193.417Z",
    fill: "white"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M278.698 118.312L278.667 132.358L233.772 161.828L233.802 147.782L278.698 118.312Z",
    fill: "#F0F0F0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M233.802 147.782L233.772 161.828L188.571 132.358L188.601 118.312L233.802 147.782Z",
    fill: "#F0F0F0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M278.698 118.312L233.802 147.782L188.601 118.312L233.512 88.8598L278.698 118.312Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M322.842 147.5L322.812 161.545L277.916 191.015L277.946 176.969L322.842 147.5Z",
    fill: "#F0F0F0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277.946 176.969L277.916 191.015L232.715 161.545L232.745 147.5L277.946 176.969Z",
    fill: "#F0F0F0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M322.842 147.5L277.946 176.969L232.745 147.5L277.656 118.047L322.842 147.5Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M277.778 176.687L277.748 190.732L232.852 220.202L232.883 206.156L277.778 176.687Z",
    fill: "#F0F0F0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M232.882 206.156L232.852 220.202L187.651 190.732L187.681 176.687L232.882 206.156Z",
    fill: "#F0F0F0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M277.778 176.687L232.882 206.157L187.681 176.687L232.592 147.234L277.778 176.687Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M367.906 176.687L367.875 190.732L322.979 220.202L323.01 206.156L367.906 176.687Z",
    fill: "#F0F0F0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M323.01 206.156L322.979 220.202L277.778 190.732L277.809 176.687L323.01 206.156Z",
    fill: "#F0F0F0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M367.906 176.687L323.01 206.157L277.809 176.687L322.72 147.234L367.906 176.687Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M446.078 132.906L446.047 146.951L401.151 176.421L401.182 162.376L446.078 132.906Z",
    fill: "#F0F0F0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M401.182 162.376L401.151 176.421L355.95 146.951L355.981 132.906L401.182 162.376Z",
    fill: "#F0F0F0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M446.078 132.906L401.182 162.376L355.981 132.906L400.892 103.453L446.078 132.906Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M535.285 132.906L535.255 146.951L490.359 176.421L490.39 162.376L535.285 132.906Z",
    fill: "#F0F0F0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M490.39 162.376L490.359 176.421L445.158 146.951L445.188 132.906L490.39 162.376Z",
    fill: "#F0F0F0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M535.285 132.906L490.39 162.376L445.188 132.906L490.1 103.453L535.285 132.906Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M657.601 121.08L657.571 135.125L612.675 164.595L612.705 150.55L657.601 121.08Z",
    fill: "#F0F0F0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M612.705 150.55L612.675 164.595L567.474 135.125L567.504 121.08L612.705 150.55Z",
    fill: "#F0F0F0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M657.601 121.08L612.705 150.55L567.504 121.08L612.415 91.6272L657.601 121.08Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M701.745 150.015L701.715 164.06L656.819 193.53L656.849 179.484L701.745 150.015Z",
    fill: "#F0F0F0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M656.849 179.484L656.819 193.53L611.618 164.06L611.648 150.015L656.849 179.484Z",
    fill: "#F0F0F0"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M701.745 150.015L656.849 179.485L611.648 150.015L656.559 120.562L701.745 150.015Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M188.738 176.969L188.708 191.015L143.507 161.545L143.537 147.5L188.738 176.969Z",
    fill: "#F0F0F0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M233.634 147.5L188.738 176.969L143.537 147.5L188.448 118.047L233.634 147.5Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M145.514 148.825L145.484 162.87L100.282 133.4L100.313 119.355L145.514 148.825Z",
    fill: "#F0F0F0"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M190.41 119.355L145.514 148.825L100.313 119.355L145.224 89.9023L190.41 119.355Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M110.399 125.902L110.368 139.948L65.4727 169.418L65.5032 155.372L110.399 125.902Z",
    fill: "#F0F0F0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M65.5031 155.372L65.4726 169.418L20.2715 139.948L20.302 125.902L65.5031 155.372Z",
    fill: "#F0F0F0"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M110.399 125.902L65.5031 155.372L20.302 125.902L65.213 96.4497L110.399 125.902Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M108.727 181.413L108.697 195.459L63.4958 165.989L63.5264 151.944L108.727 181.413Z",
    fill: "#F0F0F0"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M153.623 151.944L108.727 181.414L63.5264 151.944L108.437 122.491L153.623 151.944Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M67.1746 154.837L67.1441 168.883L22.2483 198.353L22.2788 184.307L67.1746 154.837Z",
    fill: "#F0F0F0"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M22.2787 184.307L22.2482 198.353L-22.9529 168.883L-22.9223 154.837L22.2787 184.307Z",
    fill: "#F0F0F0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1745 154.837L22.2787 184.307L-22.9224 154.837L21.9887 125.385L67.1745 154.837Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M21.1912 183.772L21.1607 197.818L-23.7351 227.287L-23.7046 213.242L21.1912 183.772Z",
    fill: "#F0F0F0"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1911 183.772L-23.7047 213.242L-68.9058 183.772L-23.9947 154.32L21.1911 183.772Z",
    fill: "white"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M63.4959 210.778L63.4654 224.824L18.5696 254.293L18.6001 240.248L63.4959 210.778Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M18.6 240.248L18.5695 254.293L-26.6316 224.824L-26.6011 210.778L18.6 240.248Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4958 210.778L18.6 240.248L-26.6011 210.778L18.31 181.325L63.4958 210.778Z",
    fill: "white"
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M152.871 211.313L152.841 225.358L107.64 195.889L107.67 181.843L152.871 211.313Z",
    fill: "#F0F0F0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M197.767 181.843L152.871 211.313L107.67 181.843L152.581 152.391L197.767 181.843Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M234.554 90.1676L189.658 119.637L144.457 90.1676L189.368 60.715L234.554 90.1676Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M242.831 211.086L242.801 225.131L197.905 254.601L197.935 240.556L242.831 211.086Z",
    fill: "#F0F0F0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M197.935 240.556L197.905 254.601L152.704 225.131L152.734 211.086L197.935 240.556Z",
    fill: "#F0F0F0"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M242.831 211.086L197.935 240.556L152.734 211.086L197.645 181.633L242.831 211.086Z",
    fill: "white"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M197.767 240.677L197.737 254.723L152.841 284.193L152.872 270.147L197.767 240.677Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.767 240.677L152.871 270.147L107.67 240.677L152.581 211.225L197.767 240.677Z",
    fill: "white"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M490.222 162.093L490.191 176.139L445.295 205.609L445.326 191.563L490.222 162.093Z",
    fill: "#F0F0F0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M445.326 191.563L445.295 205.609L400.094 176.139L400.125 162.093L445.326 191.563Z",
    fill: "#F0F0F0"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M490.222 162.093L445.326 191.563L400.125 162.093L445.036 132.641L490.222 162.093Z",
    fill: "white"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M412.218 264.613L412.187 278.658L366.986 249.188L367.017 235.143L412.218 264.613Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.113 235.143L412.218 264.613L367.017 235.143L411.928 205.69L457.113 235.143Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.05 205.956L367.154 235.425L321.953 205.956L366.864 176.503L412.05 205.956Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M502.269 264.434L502.239 278.48L457.343 307.949L457.374 293.904L502.269 264.434Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M457.373 293.904L457.343 307.949L412.142 278.48L412.172 264.434L457.373 293.904Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.269 264.434L457.373 293.904L412.172 264.434L457.083 234.981L502.269 264.434Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M613.457 281.687L613.427 295.733L568.531 325.202L568.561 311.157L613.457 281.687Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M568.561 311.157L568.531 325.202L523.33 295.733L523.36 281.687L568.561 311.157Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.457 281.687L568.561 311.157L523.36 281.687L568.271 252.235L613.457 281.687Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M658.521 252.5L613.625 281.97L568.424 252.5L613.335 223.047L658.521 252.5Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M589.546 204.275L589.515 218.321L544.619 247.79L544.65 233.745L589.546 204.275Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M544.65 233.745L544.619 247.79L499.418 218.321L499.449 204.275L544.65 233.745Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.546 204.275L544.65 233.745L499.449 204.275L544.36 174.823L589.546 204.275Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M703.584 282.151L703.554 296.196L658.658 325.666L658.688 311.621L703.584 282.151Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M658.689 311.621L658.658 325.666L613.457 296.196L613.488 282.151L658.689 311.621Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.584 282.151L658.689 311.621L613.488 282.151L658.399 252.698L703.584 282.151Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M366.986 235.143L366.956 249.188L322.06 278.658L322.09 264.613L366.986 235.143Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M322.09 264.613L322.06 278.658L276.859 249.188L276.889 235.143L322.09 264.613Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.986 235.143L322.09 264.613L276.889 235.143L321.8 205.69L366.986 235.143Z",
    fill: "white"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M401.934 162.093L401.903 176.139L357.007 205.609L357.038 191.563L401.934 162.093Z",
    fill: "#F0F0F0"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M357.038 191.563L357.007 205.609L311.806 176.139L311.837 162.093L357.038 191.563Z",
    fill: "#F0F0F0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M401.934 162.093L357.038 191.563L311.837 162.093L356.748 132.641L401.934 162.093Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M240.072 139.405L240.042 153.451L195.146 182.921L195.176 168.875L240.072 139.405Z",
    fill: "#F0F0F0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M195.176 168.875L195.146 182.921L149.945 153.451L149.975 139.405L195.176 168.875Z",
    fill: "#F0F0F0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M240.072 139.405L195.176 168.875L149.975 139.405L194.886 109.953L240.072 139.405Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M22.1109 115.293L22.0803 129.338L-22.8154 158.808L-22.7849 144.763L22.1109 115.293Z",
    fill: "#F0F0F0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1108 115.293L-22.785 144.763L-67.9861 115.293L-23.075 85.8402L22.1108 115.293Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M330.199 118.186L330.169 132.232L285.273 161.702L285.304 147.656L330.199 118.186Z",
    fill: "#F0F0F0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M285.304 147.656L285.273 161.702L240.072 132.232L240.103 118.186L285.304 147.656Z",
    fill: "#F0F0F0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M330.199 118.186L285.304 147.656L240.103 118.186L285.014 88.7337L330.199 118.186Z",
    fill: "white"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M108.727 240.248L108.697 254.293L63.4958 224.824L63.5264 210.778L108.727 240.248Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.623 210.778L108.727 240.248L63.5264 210.778L108.437 181.325L153.623 210.778Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M152.704 269.612L152.673 283.658L107.777 313.128L107.808 299.082L152.704 269.612Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M107.808 299.082L107.777 313.128L62.5762 283.658L62.6067 269.612L107.808 299.082Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.704 269.612L107.808 299.082L62.6067 269.612L107.518 240.16L152.704 269.612Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudTablet);
export default __webpack_public_path__ + "static/media/Cloud_Tablet.4151d6cde214c5159b99aa39fb4f4c2e.svg";
export { ForwardRef as ReactComponent };